
$(document).ready(function() {

var lang = $('#lang-list-desktop-header .disclosure-list__item--current ').find('a').attr('data-value');

  $('#contact').addClass(lang);

 var CV =$(".cs-form-wrap").find('.element-group #cV'); 
  $('<div class="file_input"><span class="input-group-text" id="text_input_span_id">Choisir le fichier</span><input type="text" id="text_input_id" class="form-control" placeholder="aucun fichier sélectionné"style="caret-color: transparent" autocomplete="off"></div>' ).insertAfter( CV );

 // bind file-input-form click action to text-input-span
    $('#text_input_span_id').click(function () {
        $("#cV").trigger('click');
    })
   $('#text_input_id').click(function () {
        $("#cV").trigger('click');
    })
  
    // display file name in text-input-form    
    $("#cV").change(function () {
        $('#text_input_id').val(this.value.replace(/C:\\fakepath\\/i, ''))
    })


 var Mediakit_file =$(".cs-form-wrap").find('.element-group #Envoyez_votre_kit_média'); 
  $('<div class="file_input"><span class="input-group-text" id="mediakit_span_id">Choisir le fichier</span><input type="text" id="mediakit_file" class="form-control" placeholder="aucun fichier sélectionné"style="caret-color: transparent" autocomplete="off"></div>' ).insertAfter( Mediakit_file );

 // bind file-input-form click action to text-input-span
    $('#mediakit_span_id').click(function () {
        $("#Envoyez_votre_kit_média").trigger('click');
    })
    $('#mediakit_file').click(function () {
        $("#Envoyez_votre_kit_média").trigger('click');
    })
    // display file name in text-input-form    
    $("#Envoyez_votre_kit_média").change(function () {
        $('#mediakit_file').val(this.value.replace(/C:\\fakepath\\/i, ''))
    })



 var Invoice_file =$(".cs-form-wrap").find('.element-group #video'); 
  $('<div class="file_input"><span class="input-group-text" id="invoice_span_id">Choisir le fichier</span><input type="text" id="invoice_file" class="form-control" placeholder="aucun fichier sélectionné"style="caret-color: transparent" autocomplete="off"></div>' ).insertAfter( Invoice_file );

 // bind file-input-form click action to text-input-span
    $('#invoice_span_id').click(function () {
        $("#video").trigger('click');
    })
   $('#invoice_file').click(function () {
        $("#video").trigger('click');
    })
    // display file name in text-input-form    
    $("#video").change(function () {
        $('#invoice_file').val(this.value.replace(/C:\\fakepath\\/i, ''))
    })



 var Vdo_file =$(".cs-form-wrap").find('.element-group #file'); 
  $('<div class="file_input"><span class="input-group-text" id="vdofile_span_id">Choisir le fichier</span><input type="text" id="vdofile_input_id" class="form-control" placeholder="aucun fichier sélectionné"style="caret-color: transparent" autocomplete="off"></div>' ).insertAfter( Vdo_file );

 // bind file-input-form click action to text-input-span
    $('#vdofile_span_id').click(function () {
        $("#file").trigger('click');
    })
   $('#vdofile_input_id').click(function () {
        $("#file").trigger('click');
    })
    // display file name in text-input-form    
    $("#file").change(function () {
        $('#vdofile_input_id').val(this.value.replace(/C:\\fakepath\\/i, ''))
    })

$('.element-group #cV').hide();
$('.element-group #Envoyez_votre_kit_média').hide();
$('.element-group #video').hide();
$('.element-group #file').hide();

  
var title =$(".cs-form-wrap").find('.element-group h1'); 
var sub_title =$(".cs-form-wrap").find('.element-group label[for="Objet"]');
var sel_option0 =$(".cs-form-wrap").find('.condition-trigger option:eq(0)'); 
var sel_option1 =$(".cs-form-wrap").find('.condition-trigger option:eq(1)'); 
var sel_option2=$(".cs-form-wrap").find('.condition-trigger option:eq(2)'); 
var sel_option3 =$(".cs-form-wrap").find('.condition-trigger option:eq(3)'); 
var sel_option4 =$(".cs-form-wrap").find('.condition-trigger option:eq(4)'); 
var sel_option5 =$(".cs-form-wrap").find('.condition-trigger option:eq(5)'); 
 
 
   
   //console.log(file_type);
  var name =$(".cs-form-wrap").find('.element-group label[for="prenom"]');
  var name_placeholder =$(".cs-form-wrap").find('.element-group #prenom');
  
  var lname =$(".cs-form-wrap").find('.element-group label[for="nom"]');
  var lname_placeholder =$(".cs-form-wrap").find('.element-group #nom');

  var Company =$(".cs-form-wrap").find('.element-group label[for="Société"]');
  var Company_placeholder =$(".cs-form-wrap").find('.element-group #Société');

  var Country =$(".cs-form-wrap").find('.element-group label[for="pays"]');
  var Country_placeholder =$(".cs-form-wrap").find('.element-group #pays');
  
  var Phone =$(".cs-form-wrap").find('.element-group label[for="Téléphone"]');
  
  var message =$(".cs-form-wrap").find('.element-group label[for="Votre_message"]');
  var msg_placeholder =$(".cs-form-wrap").find('.element-group textarea[name="Votre_message"]');
  
    var email =$(".cs-form-wrap").find('.element-group label[for="email"]');
  var email_placeholder =$(".cs-form-wrap").find('.element-group #email');

  var button =$(".cs-form-wrap").find('.element-group button[type="submit"]');
  var Invoice =$(".cs-form-wrap").find('.element-group label[for="video"]');
  var Video =$(".cs-form-wrap").find('.element-group label[for="file"]');

  var order_number =$(".cs-form-wrap").find('.element-group label[for="ref_commande"]');
  var orde_placeholder =$(".cs-form-wrap").find('.element-group #ref_commande');

  var tik_tok =$(".cs-form-wrap").find('.element-group label[for="textVotre_compte_TikTok"]');
  var tiktok_placeholder =$(".cs-form-wrap").find('.element-group #textVotre_compte_TikTok');

   var instagram =$(".cs-form-wrap").find('.element-group label[for="Votre_page_Instagram"]');
  var instagram_placeholder =$(".cs-form-wrap").find('.element-group #Votre_page_Instagram');

  var facebook =$(".cs-form-wrap").find('.element-group label[for="Votre_page_Facebook"]');
  var facebook_placeholder =$(".cs-form-wrap").find('.element-group #Votre_page_Facebook');
  
  var media_kit =$(".cs-form-wrap").find('.element-group label[for="Envoyez_votre_kit_média"]');
  var paragraph =$(".cs-form-wrap").find('.element-group p');
  var Cv =$(".cs-form-wrap").find('.element-group label[for="cV"]');

 var CV_span =$(".cs-form-wrap").find('.element-group #text_input_span_id');
 var CV_input =$(".cs-form-wrap").find('.element-group #text_input_id');

  var media_span =$(".cs-form-wrap").find('.element-group #mediakit_span_id');
 var media_input =$(".cs-form-wrap").find('.element-group #mediakit_file');

  var Invoice_span =$(".cs-form-wrap").find('.element-group #invoice_span_id');
 var Invoice_input =$(".cs-form-wrap").find('.element-group #invoice_file');

  var filevdo_span =$(".cs-form-wrap").find('.element-group #vdofile_span_id');
 var filevdo_input =$(".cs-form-wrap").find('.element-group #vdofile_input_id');

// var CV_span =$(".cs-form-wrap").find('.element-group #text_input_span_id');
//  var CV_input =$(".cs-form-wrap").find('.element-group #text_input_id');
 
  
//   $('.element-group .file_input').hide();
// $('.element-group #cV').show();
// $('.element-group #Envoyez_votre_kit_média').show();
// $('.element-group #video').show();
// $('.element-group #file').show();

var Country_reseller =$(".cs-form-wrap").find('.element-group label[for="Country_resellerselect"]');
  var sel_option_1 =$(".cs-form-wrap").find('#Country_resellerselect option:eq(0)'); 
   var sel_option_2 =$(".cs-form-wrap").find('#Country_resellerselect option:eq(1)'); 
  var sel_option_3 =$(".cs-form-wrap").find('#Country_resellerselect option:eq(2)');

if( lang=='en' ){

  var en_title='Contact Form';
  var en_subtitle='Subject of your request';
  var en_option0='Request Product Information';
  var en_option1='Become Reseller';
  var en_option2='Defective Product';
  var en_option3='Apply';
  var en_option4='Invoice Request';
  var en_option5='Partnership';
  var en_name='First Name';
  var en_placeholder='First Name';
  var en_lname='Last Name';
  var en_lplaceholder='Last Name';
  var en_Company='Company';
  var en_compplaceholder='Company';
  var en_Country='Country';
  var en_Countryplace='Country of residence';
  var en_Phone='Phone';
  var en_message='Your message';
  var en_msgplace='Your message';
  var en_email='Email';
  var en_emailplace='Enter Email';
  var en_button='Send';
  var en_Invoice='Invoice';
  var en_Video='Video of the problem';
  var en_order='Order Number';
  var en_orderplace='Order ref';
  var en_tik_tok='Your Tik-Tok account';  
  var en_tiktok_place=' Enter URL, example https://www.tiktok.com/username';
  var en_instagram='Your Instagram account';  
  var en_instagram_place=' Enter URL, example : https://instagram.com/littlebigfriends';
  var en_facebook='Your Facebook page';  
  var en_facebook_place='Enter URL, example : https://facebook.com/littlebigfriends';
  var en_mediakit='Media kit';  
  var en_paragraph='It is necessary to send a proof of the malfunction and the invoice of the product concerned';  
  var en_cv='Resume';
  var en_cvspan='Choose File';
  var en_cvinput='No file chosen'; 
  var en_mediaspan='Choose File';
  var en_mediainput='No file chosen';
  var en_invoicespan='Choose File';
  var en_invoiceinput='No file chosen';
  var en_vfilespan='Choose File';
  var en_vfileinput='No file chosen';
}
  else if( lang=='fr' ) {
  //   var en_title='Formulaire de contact';
   //var en_subtitle='Sujet de votre demande';
    //var en_option0='Devenir revendeur';
   // var en_option1='Demander des informations sur le produit';
  //   var en_option2='Produit defectueux';
  //   var en_option3='Appliquer';
  //   var en_option4='Demande de facturation';
  //   var en_option5='Partenariat';
     var en_button='envoyer';
     var en_tiktok_place= "Entrez l'url - Example https://www.tiktok.com/username";
     var en_instagram_place=" Entrez l'url, Example : https://instagram.com/cloudb"; 
     var en_facebook_place="Entrez l'url, Example : https://facebook.com/cloudb"; 
     var en_email='E-mail';
     var en_emailplace='Entrez l e-mail';
    var en_Country_reseller='Pays';
    var en_sel_option_1='Sélectionnez le revendeur du pays';
    var en_sel_option_2='Autre';
    var en_sel_option_3='France';
 
 }
else if( lang=='de' ){

  var en_title='Kontakt Formular';
  var en_subtitle='Thema Ihrer Anfrage';
  var en_option0='Produktinformationen anfordern';
  var en_option1='Werden Sie Wiederverkäufer';
  var en_option2='Defektes Produkt';
  var en_option3='Bewerben';
  var en_option4='Rechnungsanfrage';
  var en_option5='Partnerschaft';
  var en_name='Vorname';
  var en_placeholder='Vorname';
  var en_lname='Familienname, Nachname';
  var en_lplaceholder='Familienname, Nachname';
  var en_Company='Unternehmen';
  var en_compplaceholder='Aufenthaltsland';
  var en_Country='Zahlt';
  var en_Countryplace='Zahlt';
  var en_Phone='Telefon';
  var en_message='Ihre Nachricht';
  var en_msgplace='Ihre Nachricht';
  var en_email='Email';
  var en_emailplace='Email eingeben';
  var en_button='Schicken';
  var en_Invoice='Fakt';
  var en_Video='Video des Problems';
  var en_order='Bestellnummer';
  var en_orderplace='Bestellnr';
  var en_tik_tok='Ihr Tik-Tok-Konto';  
  var en_tiktok_place=' URL eingeben, Example https://www.tiktok.com/username';
  var en_instagram='Dein Instagram-Konto';  
  var en_instagram_place=' URL eingebenL, Example : https://instagram.com/littlebigfriends';
  var en_facebook='Ihre Facebook-Seite';  
  var en_facebook_place='URL eingeben, Example : https://facebook.com/littlebigfriends';
  var en_mediakit='Media kit';  
  var en_paragraph='Es ist erforderlich, einen Nachweis der Störung und die Rechnung des betreffenden Produkts einzusenden';  
  var en_cv='Lebenslauf';
  var en_cvspan='Datei wählen';
  var en_cvinput='Keine Datei ausgewählt'; 
  var en_mediaspan='Datei wählen';
  var en_mediainput='Keine Datei ausgewählt';
  var en_invoicespan='Datei wählen';
  var en_invoiceinput='Keine Datei ausgewählt';
  var en_vfilespan='Datei wählen';
  var en_vfileinput='Keine Datei ausgewählt';

   var en_Country_reseller='Zahlt';
  var en_sel_option_1='Wählen Sie „Landeshändler“ aus';
  var en_sel_option_2='Andere';
  var en_sel_option_3='Frankreich';

}
else if( lang=='es' ){

var en_title='Formulario de Contacto';
var en_subtitle='Tema de tu solicitud';
var en_option0='Solicitar información del producto';
var en_option1='Conviértete en revendedor';
var en_option2='Producto Defectuoso';
var en_option3='Aplicar';
var en_option4='Petición de factura';
var en_option5='Camaradería';
var en_name='Nombre de pila';
var en_placeholder='Nombre de pila';
var en_lname='Apellido';
var en_lplaceholder='Apellido';
var en_Company='Compañía';
var en_compplaceholder='Compañía';
var en_Country='País';
var en_Countryplace='País de residencia';
var en_Phone='Teléfono';
var en_message='Vuestro mensaje';
var en_msgplace='Vuestro mensaje';
var en_email='Correo electrónico';
var en_emailplace='Ingrese correo electrónico';
var en_button='Enviar a';
var en_Invoice='Factura';
var en_Video='Vídeo del problema';
var en_order='Número de orden';
var en_orderplace='Referencia del pedido';
var en_tik_tok='Tu cuenta Tik-Tok';  
var en_tiktok_place='Introducir URL, example https://www.tiktok.com/username';
var en_instagram='Tu cuenta de instagram';  
var en_instagram_place=' Introducir URL, example : https://instagram.com/littlebigfriends';
var en_facebook='Tu pagina de facebook';  
var en_facebook_place='Introducir URL, Example : https://facebook.com/littlebigfriends';
var en_mediakit='kit de medios';  
var en_paragraph='Es necesario enviar prueba del mal funcionamiento y la factura del producto en cuestión.';  
var en_cv='Reanudar';
   var en_cvspan='Elija el archivo';
  var en_cvinput='ningún archivo elegido'; 
  var en_mediaspan='Elija el archivo';
  var en_mediainput='ningún archivo elegido';
  var en_invoicespan='Elija el archivo';
  var en_invoiceinput='ningún archivo elegido';
  var en_vfilespan='Elija el archivo';
  var en_vfileinput='ningún archivo elegido';
  
  var en_Country_reseller='País';
  var en_sel_option_1='Seleccione el distribuidor del país';
var en_sel_option_2='Otro';
var en_sel_option_3='Francia';

}

else if( lang=='it' ){

var en_title='Modulo di Contatto';
var en_subtitle='Oggetto della vostra richiesta';
var en_option0='Richiedi informazioni sul prodotto ';
var en_option1='Diventa un rivenditore';
var en_option2='Prodotto difettoso';
var en_option3='Applicare';
var en_option4='Richiesta di fattura';
var en_option5='Associazione';
var en_name='Nome';
var en_placeholder='Nome';
var en_lname='Cognome';
var en_lplaceholder='Cognome';
var en_Company='Azienda';
var en_compplaceholder='Azienda';
var en_Country='Paese';
var en_Countryplace='Paese di residenza';
var en_Phone='Telefono';
var en_message='Il tuo messaggio';
var en_msgplace='Il tuo messaggio';
var en_email='E-mail';
var en_emailplace="Inserisci l'email";
var en_button='Mandare';
var en_Invoice='Fattura';
var en_Video='Video del problema';
var en_order="Numero d'ordine";
var en_orderplace='Ordine rif';
var en_tik_tok='Il tuo account Tik-Tok';  
var en_tiktok_place="Inserisci l'URL, example https://www.tiktok.com/username";
var en_instagram='Il tuo account Instagram';  
var en_instagram_place="Inserisci l'URL, example : https://instagram.com/littlebigfriends";
var en_facebook='La tua pagina Facebook';  
var en_facebook_place="Inserisci l'URL, Example : https://facebook.com/littlebigfriends";
var en_mediakit='Media kit ';  
var en_paragraph='È necessario inviare la prova del malfunzionamento e la fattura del prodotto in questione';  
var en_cv='Riprendere';
var en_cvspan='Scegli il file';
var en_cvinput='Nessun file scelto'; 
var en_mediaspan='Scegli il file';
var en_mediainput='Nessun file scelto';
var en_invoicespan='Scegli il file';
var en_invoiceinput='Nessun file scelto';
var en_vfilespan='Scegli il file';
var en_vfileinput='Nessun file scelto';
  
  var en_Country_reseller='Paese';
  var en_sel_option_1='Seleziona Paese rivenditore';
var en_sel_option_2='Altro';
var en_sel_option_3='Francia';

}


  
  $(title).html(en_title);
  $(sub_title).html(en_subtitle);
  $(sel_option0).text(en_option0);
  $(sel_option1).text(en_option1);
  $(sel_option2).html(en_option2);
  $(sel_option3).html(en_option3);
  $(sel_option4).html(en_option4);
  $(sel_option5).html(en_option5);
  $(name).html(en_name); 
  $(name_placeholder).attr('placeholder',en_placeholder);
  $(lname).html(en_lname); 
  $(lname_placeholder).attr('placeholder',en_lplaceholder);
  $(Company).html(en_Company); 
  $(Company_placeholder).attr('placeholder',en_compplaceholder);
  $(Country).html(en_Country); 
  $(Country_placeholder).attr('placeholder',en_Countryplace);
  $(Phone).html(en_Phone); 
  $(message).html(en_message); 
  $(msg_placeholder).attr('placeholder',en_msgplace);
  $(email).html(en_email); 
  $(email_placeholder).attr('placeholder',en_emailplace);
  $(button).html(en_button); 
  $(Invoice).html(en_Invoice); 
  $(Video).html(en_Video); 
  $(order_number).html(en_order); 
  $(orde_placeholder).attr('placeholder',en_orderplace);
  $(tik_tok).html(en_tik_tok); 
   $(tiktok_placeholder).attr('placeholder',en_tiktok_place);
  $(instagram).html(en_instagram); 
   $(instagram_placeholder).attr('placeholder',en_instagram_place);
  $(facebook).html(en_facebook); 
  $(facebook_placeholder).attr('placeholder',en_facebook_place);
  $(media_kit).html(en_mediakit); 
  $(paragraph).html(en_paragraph); 
  $(Cv).html(en_cv); 
  
  $(CV_span).html(en_cvspan); 
  $(CV_input).attr('placeholder',en_cvinput);
  
  $(media_span).html(en_mediaspan); 
  $(media_input).attr('placeholder',en_mediainput);
  
  (Invoice_span).html(en_invoicespan); 
  $(Invoice_input).attr('placeholder',en_invoiceinput);

  (filevdo_span).html(en_vfilespan); 
  $(filevdo_input).attr('placeholder',en_vfileinput);


   
  $(Country_reseller).html(en_Country_reseller); 
  $(sel_option_1).html(en_sel_option_1);
  $(sel_option_2).html(en_sel_option_2);
  $(sel_option_3).html(en_sel_option_3);

});
  

